import React, { useMemo } from 'react';
import MembersTableSection from './MembersTableSection';
import useTranslate from '../../../../../customHooks/useTranslate';
import Card from '../../../../../muiComponents/Card';
import { useZinantisMembers } from '../../../../contextsProperty/ContextZinantisMembers';

const MembersTableView = () => {
    const {
        members,
        membersWithoutSegment,
        connectedMembers,
        newMembers,
        accountManagmentSegments,
        getFilteredMembers,
        filters,
    } = useZinantisMembers();
    const translate = useTranslate();

    const filteredConnectedMembers = useMemo(() => {
        return getFilteredMembers(connectedMembers);
    }, [connectedMembers, filters]);

    const filteredNewMembers = useMemo(() => {
        return getFilteredMembers(newMembers);
    }, [newMembers, filters]);

    const filteredMembersWithoutSegment = useMemo(() => {
        return getFilteredMembers(membersWithoutSegment);
    }, [membersWithoutSegment, filters]);

    const filteredMembers = useMemo(() => {
        return getFilteredMembers(members);
    }, [members, filters]);

    return (
        <div className='overflow-y-auto flex-column gap-20 padding-right10'>
            {filteredConnectedMembers.length > 0 && (
                <MembersTableSection
                    name={translate('my_connections')}
                    totalMembersCount={connectedMembers.length}
                    items={filteredConnectedMembers}
                    visibleSegmentName={true}
                    visibleNewMember={true}
                />
            )}
            {filteredNewMembers.length > 0 && (
                <MembersTableSection
                    totalMembersCount={newMembers.length}
                    name={translate('new_plural')}
                    items={filteredNewMembers}
                    visibleSegmentName={true}
                />
            )}
            {accountManagmentSegments.map(segment => {
                const segmentMembers = members.filter(
                    member =>
                        member.idAccountManagmentSegment ===
                        parseInt(segment.id)
                );
                const filteredSegmentMembers =
                    getFilteredMembers(segmentMembers);

                if (!filteredSegmentMembers.length) return null;
                return (
                    <MembersTableSection
                        key={segment.id}
                        name={segment.name}
                        items={filteredSegmentMembers}
                        visibleNewMember={true}
                        totalMembersCount={segmentMembers.length}
                    />
                );
            })}
            {filteredMembersWithoutSegment.length > 0 ? (
                <MembersTableSection
                    totalMembersCount={membersWithoutSegment.length}
                    name={translate('other-rest')}
                    items={filteredMembersWithoutSegment}
                    visibleNewMember={true}
                />
            ) : (
                ''
            )}
            {filteredMembers.length === 0 && (
                <Card className='padding20'>
                    <p className='text-align-center'>
                        {translate('no_results')}
                    </p>
                </Card>
            )}
        </div>
    );
};

export default MembersTableView;
